import { Http } from './../helpers'

export const DashboardService = {
  workstatus,
  jobstatus,
  checkRole,
  countStatus,
  countStatusฺAllProject,
  menu,
}

function workstatus(params = {}) {
  return Http.get('/dashboard/count-inform-status', { params: params })
}

function jobstatus(params = {}) {
  return Http.get('/dashboard/count-job-status', { params: params })
}
function countStatus(params = {}) {
  return Http.get('/dashboard/count-status', { params: params })
}
function countStatusฺAllProject(params = {}) {
  return Http.get('/dashboard/count-status-all-project', { params: params })
}
function checkRole(params = {}) {
  return Http.get('/dashboard/check-role', { params: params })
}
function menu(params = {}) {
  return Http.get('/dashboard/menu', { params: params })
}
